export default [
  {
    title: 'Trust',
    icon: 'i-check-mark-2',
    context: 'Trust is the basis of successful business relationships. Our hard work and dedication have earned us the trust of the world’s renowned research and pharmaceutical organizations.',
  },
  {
    title: 'Quality',
    icon: 'i-check-mark-1',
    context: 'High-quality work always pays back. In our case, the reward is not only financial but also human, expressed in the faces of healthy patients. This is the result of hard work, total transparency, and commitment to what we do.',
  }, {
    title: 'Care',
    icon: 'i-hands-with-heart',
    context: 'Care is the cornerstone of our organization. It starts within our team and spreads out to our clients and their patients. ',
  },
];
